const genderOptions = [
  {
    name: "Male",
    value: "Male"
  }, {
    name: "Female",
    value: "Female"
  }
]


export default genderOptions;



/** WEBPACK FOOTER **
 ** ./src/forms/options/gender.js
 **/